const  CourseDurationOptions = {
    yearly: 12,
    semiannual: 6,
}
export default CourseDurationOptions;